import React, { useState, useEffect } from 'react';
import { downloadFile, apiGet } from '../utils/api';
import LoadingSpinner from './common/LoadingSpinner';
import ErrorMessage from './common/ErrorMessage';
import './Notice.css';

function Notice() {
  const [downloading, setDownloading] = useState(false);
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formFiles, setFormFiles] = useState([]);

  useEffect(() => {
    fetchNotices();
    fetchFormFiles();
  }, []);

  const fetchNotices = async () => {
    try {
      setLoading(true);
      const data = await apiGet('/api/notices/?limit=10');
      setNotices(data || []);
      setError(null);
    } catch (err) {
      setError(err.message || '공지사항을 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const fetchFormFiles = async () => {
    try {
      const data = await apiGet('/api/materials/upload-form/list');
      setFormFiles(data || []);
    } catch (err) {
      // 목록 실패 시 무시
    }
  };

  const handleDownloadForm = async () => {
    try {
      setDownloading(true);
      await downloadFile('/api/materials/download/upload-form', '업로드양식.xlsx');
    } catch (error) {
      alert('파일 다운로드에 실패했습니다: ' + error.message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="notice-container">
      <h2 className="notice-page-title">공지사항</h2>
      <div className="notice-layout">
        <div className="notice-left-section">
          {loading ? (
            <LoadingSpinner message="공지사항을 불러오는 중..." />
          ) : error ? (
            <ErrorMessage message={error} type="error" />
          ) : (
            <div className="notices-list">
              {notices.length === 0 ? (
                <div className="notice-content">
                  <p>등록된 공지사항이 없습니다.</p>
                </div>
              ) : (
                notices.map(notice => (
                  <div
                    key={notice.id}
                    className={`notice-item ${notice.is_important ? 'important' : ''}`}
                  >
                    <div className="notice-item-header">
                      <h3>{notice.title}</h3>
                      {notice.is_important && (
                        <span className="important-badge">중요</span>
                      )}
                    </div>
                    <div className="notice-item-content">
                      {notice.content}
                    </div>
                    <div className="notice-item-footer">
                      작성자: {notice.created_by} | 
                      작성일: {new Date(notice.created_at).toLocaleString('ko-KR')}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <div className="notice-right-section">
          <div className="notice-download-section">
            <h3>임금대장 양식 다운로드</h3>
            {formFiles.length > 0 ? (
              <ul className="form-file-list">
                {formFiles.map((file, idx) => (
                  <li key={idx} className={`form-file-item${file.latest ? ' latest' : ''}`}>
                    <span className="form-file-name">{file.filename}</span>
                    <span className="form-file-date">{file.date}</span>
                    {file.latest ? (
                      <button
                        onClick={handleDownloadForm}
                        disabled={downloading}
                        className="btn-download"
                      >
                        {downloading ? '...' : '다운로드'}
                      </button>
                    ) : (
                      <span className="form-file-archived">보관</span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p>양식 파일이 없습니다.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notice;

